<template>
  <div>
    <table-card
      ref="datatable"
      module="VehicleType"
      :headers="headers"
      :actions="actions"
    >
      <template v-slot:action>
        <vs-button color="primary" type="gradient" class="mb-4 md:mb-0" @click="add">Add New Data</vs-button>
      </template>
    </table-card>

    <vs-popup classContent="popup-example" :title="popupTitle" :active.sync="showPopup">
      <template>
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-2/2 w-full">
            <vs-input label="Name" class="w-full" v-model="input.name" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full ml-auto">
            <vs-button :disabled="isSubmit" id="submitBtn"  class="mr-3 mb-2 vs-con-loading__container" @click="submit">Submit</vs-button>
            <vs-button :disabled="isSubmit" v-show="action === 'store'" color="warning" type="border" @click="reset" class="mb-2">Reset</vs-button>
          </div>
        </div>
      </template>
    </vs-popup>

  </div>
</template>

<script>
import TableCard from '@/components/TableCard'

export default {
  components: {
    TableCard,
  },

  data () {
    return {
      showPopup: false,
      popupTitle: '',
      action: '',
      isSubmit: false,
      input: {
        id: null,
        name: null,
      },
    }
  },

  computed: {
    headers() {
      return [
        [
          { label: 'Name', value: 'name' }
        ]
      ]
    },
    actions() {
      return [
        { name: 'Edit', action: this.edit, icon: 'icon-edit', color: 'success' },
        { name: 'Delete', action: this.del, icon: 'icon-trash', color: 'danger' },
      ]
    },
  },
  watch: {},
  created () {},
  mounted () {},

  methods: {
    initTable() {
      this.$refs.datatable.initTable()
    },

    reset() {
      Object.keys(this.input).map(item => {
        this.input[item] = null
      })
    },

    add() {
      if(this.action === 'update') this.reset()
      this.action = 'store'
      this.popupTitle = 'Add Vehicle Type'
      this.showPopup = true
    },

    async edit(id) {
      this.input.id = id
      this.action = 'update'
      this.popupTitle = 'Edit Vehicle Type'

      await this.$store.dispatch('VehicleType/detail', id).then(data => {
        this.input = data
      })
      this.showPopup = true
    },

    async submit() {
      this.isSubmit = true
      this.loadingStart('#submitBtn', 'primary')
      const {status, message} = await this.$store.dispatch(`VehicleType/${this.action}`, this.input)
      this.isSubmit = false
      this.loadingStop('#submitBtn')
      if(status) {
        this.showNotify(message)
        this.initTable()
        this.reset()
        this.showPopup = false
      }
    },

    del(id) {
      this.input.id = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Vehicle Type`,
        text: 'Are you sure want to Delete this Vehicle Type ?',
        accept: this.confirmDelete
      })
    },

    async confirmDelete() {
      const {status, message} = await this.$store.dispatch('VehicleType/delete', this.input.id)
      if(status) {
        this.showNotify(message)
        this.initTable()
      }
    },

    loadingStart(el, color = 'success') {
      this.$vs.loading({
        background: color,
        color: '#fff',
        container: el,
        scale: 0.45
      })
    },
    
    loadingStop(el) {
      this.$vs.loading.close(`${el} > .con-vs-loading`)
    },
    
    showNotify(msg, type = 'success') {
      this.$vs.notify({
        title: 'Thank You',
        text: msg,
        color: type,
        position: 'top-right'
      })
    },
  },
}
</script>
